import logoUrl from "@/assets/fionova-logo.png";

// Official FioNova circular badge (owner-supplied asset). The lockup already
// contains the mark, wordmark and tagline, so we render the asset as-is.
export const Logo = ({ size = 96, className = "" }) => {
  return (
    <div className={`flex flex-col items-center ${className}`} data-testid="fionova-logo">
      <img
        src={logoUrl}
        alt="FioNova — Mental wellness. Personal growth. Always here."
        width={size}
        height={size}
        style={{ width: size, height: size }}
        className="rounded-full object-contain"
      />
    </div>
  );
};
